import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Customer_api } from "../../../Apiconfig";
import style from './Searchcustomer.module.css';

const SearchCustomer = ({ onSelectCustomer }) => {
  const [search, setSearch] = useState("");
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [error, setError] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(search);
  const [loading, setLoading] = useState(false);
  const dropdownRef = useRef(null);

  // Effect to handle debounced search input
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
    }, 1000); 
    return () => {
      clearTimeout(handler); 
    };
  }, [search]);

  // Effect to call the API whenever the debounced search value changes
  useEffect(() => {
    if (debouncedSearch.trim() === "") {
      setCustomers([]);
      return;
    }

    const fetchCustomers = async () => {
      setLoading(true);
      try {
        const response = await axios.post(
          `${Customer_api}SearchCustomers.php`,
          { search: debouncedSearch.trim() },
          { withCredentials: true }
        );

        if (response.data.customers) {
          setCustomers(response.data.customers);
          setError("");
        } else if (response.data.error) {
          setError(response.data.error);
          setCustomers([]); 
        } else {
          setCustomers([]); 
        }
      } catch (err) {
        setError("An error occurred while searching for customers.");
        console.error(err);
        setCustomers([]); 
      } finally {
        setLoading(false);
      }
    };

    fetchCustomers();
  }, [debouncedSearch]); 

  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setCustomers([]); 
        setSearch(""); 
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelectCustomer = (customer) => {
    setSelectedCustomer(customer);
    setCustomers([]); 
    setSearch(""); 
    if (onSelectCustomer) { 
      handleCustomerSelect(customer); 
    }
  };

  const handleCustomerSelect = (customer) => {
    onSelectCustomer({
      id: customer.id,
      name: customer.customer_name,
      contact: customer.contact,
    });
  };
  
 
  return (
    <div className={style.searchinputbarrr}>
      <input
      className={style.searchBarStyle}
      
        type="text"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Search by name or contact"
      />
      
      {/* {error && <p style={{ color: "red" }}>{error}</p>} */}

      {loading && <p>Loading...</p>} 

      <div ref={dropdownRef} className={style.searchlist}>
        {customers.length > 0 ? (
          <table border="1" style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
            <tr className={style.customertablehead_tr}>
                <th>ID</th>
                <th>Name</th>
                <th>Contact</th>
                <th>City</th>
              </tr>
            </thead>
            <tbody>
              {customers.map((customer) => (
                <tr
                  key={customer.id}
                  onClick={() => handleSelectCustomer(customer)}
                  style={{ cursor: "pointer" }}
                >
                  <td>{customer.id}</td>
                  <td style={{ color: "#002e50" }}>{customer.customer_name}</td>
                  <td>{customer.contact}</td>
                  <td>{customer.city}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          !loading
        )}
      </div>

      {selectedCustomer && !onSelectCustomer && ( 
        <div style={{ marginTop: "20px", border: "1px solid #ccc", padding: "10px" }}>
          <h3>Selected Customer</h3>
          <p><strong>Name:</strong> {selectedCustomer.customer_name}</p>
          <p><strong>Contact:</strong> {selectedCustomer.contact}</p>
        </div>
      )}
    </div>
  );
};

export default SearchCustomer;
